import { useEffect } from "react";
import { Box } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";

import TabPanel from "../../../../shared/UI/TabPanel";

import AdvertisementCol from "../../../Ads/components/AdvertisementCol";
import { useUserProfile } from "../../../User/api/queries/useUserProfile";
import { useVisitMutation } from "../../../User/api/mutations/useVisitMutation";
import { useUserDataFormatter } from "../../../User/hooks/useUserDataFormatter";
import { useFollowMutation } from "../../../User/api/mutations/useFollowMutation";
import { useUnfollowMutation } from "../../../User/api/mutations/useUnfollowMutation";

import Heading from "../../components/Heading";
import NetworkTab from "../../components/NetworkTab";
import GoServiceTab from "../../components/GoServiceTab";
import TabsNavigation from "../../components/TabsNavigation";

import HomeTab from "./components/HomeTab";

const ScoutProfile = () => {
  const { userId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "home";

  const { data: profileData, isLoading: isProfileLoading, isError: isProfileError } = useUserProfile(userId!);

  const visitMutation = useVisitMutation();
  const { follow } = useFollowMutation();
  const { unfollow } = useUnfollowMutation();

  useEffect(() => {
    if (userId) {
      visitMutation.mutate(userId);
    }
  }, [userId]);

  const { fullName, firstTwoChr, countryName, role, cityName, media, isFollowing } = useUserDataFormatter(profileData);

  const handleFollowToggle = () => {
    if (!profileData) return;

    if (isFollowing) {
      unfollow(profileData);
    } else {
      follow(profileData);
    }
  };

  return (
    <Box sx={{ display: "flex", gap: "16px" }}>
      <Box sx={{ width: { xs: "100%", lg: "636px" }, display: "flex", flexDirection: "column", gap: "16px" }}>
        <Heading
          fullName={fullName}
          firstTwoChr={firstTwoChr}
          countryName={countryName}
          role={role}
          cityName={cityName}
          media={media}
          isLoading={isProfileLoading}
          isFollowing={isFollowing}
          onFollowToggle={handleFollowToggle}
        >
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabsNavigation />
          </Box>
        </Heading>

        <TabPanel value={currentTab} tab="home">
          <HomeTab profile={profileData} isLoading={isProfileLoading} />
        </TabPanel>
        <TabPanel value={currentTab} tab="network">
          <NetworkTab userId={String(userId)} />
        </TabPanel>
        <TabPanel value={currentTab} tab="goService">
          <GoServiceTab fullName={fullName} />
        </TabPanel>
      </Box>
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        <AdvertisementCol />
      </Box>
    </Box>
  );
};

export default ScoutProfile;
